// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_SERVICE_MESSAGES = 'message/fetchServiceMessages';
export const {
  pending: FETCH_SERVICE_MESSAGES_PENDING,
  fulfilled: FETCH_SERVICE_MESSAGES_FULFILLED,
  rejected: FETCH_SERVICE_MESSAGES_REJECTED,
} = createAsyncActionTypes(FETCH_SERVICE_MESSAGES);

export const FETCH_PLATFORMS = 'message/fetchPlatforms';
export const {
  pending: FETCH_PLATFORMS_PENDING,
  fulfilled: FETCH_PLATFORMS_FULFILLED,
  rejected: FETCH_PLATFORMS_REJECTED,
} = createAsyncActionTypes(FETCH_PLATFORMS);

export const CREATE_SERVICE_MESSAGE = 'message/createServiceMessage';
export const {
  pending: CREATE_SERVICE_MESSAGE_PENDING,
  fulfilled: CREATE_SERVICE_MESSAGE_FULFILLED,
  rejected: CREATE_SERVICE_MESSAGE_REJECTED,
} = createAsyncActionTypes(CREATE_SERVICE_MESSAGE);

export const UPDATE_SERVICE_MESSAGE = 'message/updateServiceMessage';
export const {
  pending: UPDATE_SERVICE_MESSAGE_PENDING,
  fulfilled: UPDATE_SERVICE_MESSAGE_FULFILLED,
  rejected: UPDATE_SERVICE_MESSAGE_REJECTED,
} = createAsyncActionTypes(UPDATE_SERVICE_MESSAGE);
